import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { PaymentMethodsService } from '@core/services/payment-methods.service';
import { ValidationsService } from '@core/services/validations.service';
import { Constants } from '@shared/class/constants.class';
import { PaymentMethod } from '@shared/interfaces/payment-method';

@Component({
  selector: 'app-payment-methods-edit',
  templateUrl: './payment-methods-edit.component.html'
})
export class PaymentMethodsEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public paymentMethod: PaymentMethod;
  public paymentMethodForm: FormGroup;

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private paymentMethodsService: PaymentMethodsService,
    public dialogRef: MatDialogRef<PaymentMethodsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    if (
      this.data.action === this.appConfig.ACTIONS.edit.id ||
      this.data.action === this.appConfig.ACTIONS.add.id
    ) {
      this.constants.title = this.appConfig.LANG.paymentMethods.title;
      this.constants.action = this.data.action;

      this.paymentMethodForm = new FormGroup({
        id: new FormControl('', [
          Validators.required,
          ValidationsService.isInvalidNumberValidator
        ]),
        name: new FormControl('', Validators.required)
      });
      if (this.constants.action === this.appConfig.ACTIONS.edit.id) {
        this.constants.title =
          this.appConfig.LANG.title.edit + ' ' + this.constants.title;
        this.paymentMethod = this.data.item;
        this.paymentMethodForm.patchValue({
          id: this.paymentMethod.id,
          name: this.paymentMethod.name
        });
      } else if (this.constants.action === this.appConfig.ACTIONS.add.id) {
        this.constants.title =
          this.appConfig.LANG.title.add + ' ' + this.constants.title;
      }
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.paymentMethodForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.constants.action,
        form,
        this.dialogRef,
        this.paymentMethodsService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }
}
